export default "__VITE_ASSET__CwOL5STW__"